// src/contexts/AuthContext.js

import React, { createContext, useState, useEffect } from 'react';
import AuthServices from '../services/Auth.services';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLogged, setIsLogged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);

  const navigate = useNavigate();

  const login = (credentials) => {
    setIsLoading(true);
    AuthServices.login(credentials)
      .then((res) => {        
        setUser(res.data.user);
        setIsLogged(true);
        localStorage.setItem('access_token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.data.user));
        navigate('/user/list');
      })
      .catch((err) => {
        console.error('Erreur de connexion :', err.response.data.message);
        setAlertMessage({ type: "danger", text: err.response?.data?.message || "Erreur de connexion !" });
        toast.error(err.response?.data?.message || "Erreur inconnue", {
          position: "top-right",
          theme: "colored",
          className: "toast-message",
        });
        
        setIsLoading(false);
      });
  };

  const logout = () => {
    AuthServices.logout()
      .then(() => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        setIsLogged(false);
        setUser(null);
        navigate('/login');
      })
      .catch((err) => {
        console.error('Erreur de déconnexion :', err);
      });
  };

  useEffect(() => {
    if (alertMessage) {
      const timer = setTimeout(() => setAlertMessage(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [alertMessage]);

  useEffect(() => {
    const token = localStorage.getItem('access_token');    
    if (token) {
      setIsLogged(true);
      AuthServices.checkToken(token)
        .then((res) => {
          setUser(res.data.user);
        })
        .catch(() => {
          setIsLogged(false);
          setUser(null);
        });
    }else{
      console.log("pas de token");
      
      navigate('/login');
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        isLogged,
        isLoading,
        login,
        logout,
        setIsLoading,
        alertMessage,
        setAlertMessage,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
